import { hot } from "react-hot-loader/root";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./icons";

import "rbx/index.css";
import "./index.scss";

import { ApolloProvider, useQuery } from "react-apollo";

import { ToastContainer } from "react-toastify";

import gql from "graphql-tag";

import ApolloClient from "./client";

import Pages from "./pages";
import LoginPage from "./pages/Login/LoginPage";
import { VERSION } from "./config";

// import * as serviceWorker from "./serviceWorker";
export const GET_AUTH = gql`
  query authStatus {
    authStatus @client {
      status
    }
  }
`;

function IsLoggedIn() {
  const { data } = useQuery(GET_AUTH);
  return data.authStatus.status === "loggedOut" ? <LoginPage /> : <Pages />;
}

function pad(number) {
  if (number < 10) {
    return `0${number}`;
  }
  return number;
}
// eslint-disable-next-line no-extend-native
Date.prototype.toCorrectDateString = function() {
  return `${this.getFullYear()}-${pad(this.getMonth() + 1)}-${pad(
    this.getDate()
  )}T${pad(this.getHours())}:${pad(this.getMinutes())}`;
};

const App = () => (
  <Router>
    <title>TGMS v{VERSION}</title>
    <ApolloProvider client={ApolloClient}>
      <IsLoggedIn />
      <ToastContainer />
    </ApolloProvider>
  </Router>
);

const Renderer = process.env.NODE_ENV === "development" ? hot(App) : App;

ReactDOM.render(<Renderer />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
